<template>
  <div class="c-question-block__box__rate">
    <div class="c-question-block__box__rate__bar">
      <span ref="rateCountBar" :style="percentWidth"></span>
    </div>
    <p class="c-question-block__box__rate__value">
      実施率<span ref="rateCount" class="count" v-text="percentage === null ? `-` : percentage"></span><span class="unit">%</span>
    </p>
  </div>
</template>

<script setup lang="ts">
  import {computed, ref} from "vue";

  const props = withDefaults(
    defineProps<{
      percentage?: number | null;
    }>(),
    {
      percentage: null,
    }
  );
  const emit = defineEmits<{
    (e: 'update-percentage', id: any): void,
  }>()
  const rateCountBar = ref(null)
  const rateCount = ref(null)

  const percentWidth = computed(() => {
    return {'width': props.percentage === null ? 0 : props.percentage + '%'}
  })

  function animate(targetNum) {
    return new Promise((resolve, reject) => {
      let speed = 10;
      let rateCountNum = props.percentage === null ? 0 : props.percentage as number;
      let targetCountNum = targetNum
      let diff = targetCountNum - rateCountNum
      let countBar = rateCountBar.value // プログレスバーelement
      let count = rateCount.value // 実装率element
      let id = setInterval(function () {
        count.innerText = rateCountNum
        countBar.style.width = rateCountNum + '%'
        if (rateCountNum == targetCountNum) {
          clearInterval(id)
          emit('update-percentage', rateCountNum)
          resolve(true)
        }
        if (diff > 0) {
          rateCountNum++;
        } else {
          rateCountNum--;
        }
      }, speed);
    })
  }
  defineExpose({animate})
</script>
